export enum InviteCustomerFieldName {
  FirstName = 'Customer First Name',
  Email = 'Customer Email',
}
